import { TASKS } from '../constants/tasks.constants';

export const tasks = (state = {}, action = {}) => {
  const newState = { ...state };
  switch (action.type) {
    case TASKS.FETCH_TASKS:
      newState.tasks = action.value;
      break;
    case TASKS.SET_ACTIVE_TASK:
      newState.activeTask = action.payload;
      break;
    default:
      break;
  }
  return newState;
};
